import { Link } from "react-router-dom";

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-2 shrink-0">
    <span className="relative grid h-9 w-9 place-items-center rounded-xl bg-orange-500 font-display text-xl font-black text-white shadow-sm">
      C
      <span className="absolute -bottom-1 -right-1 h-3 w-3 rounded-full bg-green-700 ring-2 ring-white" />
    </span>
    <span className={`font-display text-2xl font-black tracking-tight ${light ? "text-white" : "text-gray-900"}`}>
      casa<span className="text-orange-500">deal</span>
    </span>
  </Link>
);
